import styled from 'styled-components'
import { colors } from '../../const'

export const VersionText = styled.span`
  font-size: 0.75rem;
  color: ${colors.textSecondary};
  background-color: transparent;
  padding: 2px 0px;
  border-radius: 5px;
`
